import create from "zustand";

const useAccountDefaultStore = create((set) => ({
	acctDefaults: {},
	editAcctDefaults: (obj) => set(() => ({ acctDefaults: obj })),
}));
export default useAccountDefaultStore;
